import { render } from "./DynvibeStock.vue?vue&type=template&id=0c10d22f"
import script from "./DynvibeStock.vue?vue&type=script&lang=js"
export * from "./DynvibeStock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__